
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/partnerships",
      function () {
        return require("private-next-pages/about-us/partnerships/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/partnerships"])
      });
    }
  